import React, {Component} from 'react';
import Select from 'react-select';
import {connect} from 'react-redux';
import Modal from '../../components/Modal';
import {freePlanTypeClient} from "../../actions/ClientActions";

@connect()

export default class FreePlanModal extends Component {

    constructor(props){
        super(props);
        this.state = {
            currentFreePlan : props.client.currentFreePlan
        }
    }

    changeFreePlan() {
        this.props.dispatch(freePlanTypeClient({
            clientId : this.props.client.id,
            currentFreePlan : this.state.currentFreePlan
        }));
    }

    handlePlanChange(value){

        this.setState({
            currentFreePlan : value
        });
    }

    render() {
        var actionButton = <button className="btn btn-success" onClick={this.changeFreePlan.bind(this)}>Save</button>
        return (
            <Modal actionButton={actionButton} className="modal modal-success" title={"Free Plan Type"}>
                <Select
                    placeholder="Free Plan Type..."
                    multi={false}
                    value={this.state.currentFreePlan}
                    options={this.props.client.freePlanTypes}
                    onChange={this.handlePlanChange.bind(this)}
                />
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/clients/FreePlanModal.js